module.exports = __webpack_public_path__ + "img/logo-school-8.8b406fba.png";